import {useSelector} from 'react-redux';
import {groupRiskAssessmentTabId} from '../../util/uiconstants';
import { currentResource } from '../../util/utils';

export default (tabId = null) =>
	useSelector(({activityLog, reconciliations}) => {
		const labels = currentResource.groupRiskAssessmentLabels;
		const obj = {
			[groupRiskAssessmentTabId.activityFeed]: { lastRefreshedDate :activityLog?.lastRefreshed ?? null, lastRefreshedLabel: labels?.lastRefreshedActivityFeed },
			[groupRiskAssessmentTabId.reconciliations]: {lastRefreshedDate: reconciliations?.lastRefreshed ?? null, lastRefreshedLabel: labels?.lastRefreshedReconciliation}
		};
		return tabId ? obj[tabId] : null;
	});
